import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../../shared/config/constants.config';
import {HyperwalletAuthTokenViewModel} from '../../shared/viewModels/hyperwalletAuthToken.viewModel';


@Injectable()
export class HyperwalletService {
    constructor(
        private readonly constants: Constants,
        private readonly httpClient: HttpClient
    ) {
    }

    generateClientToken(): Observable<HyperwalletAuthTokenViewModel> {
        return this.httpClient.get<HyperwalletAuthTokenViewModel>(`${this.constants.apiURL()}/hyperwallet/client-token/`);
    }
}
